export default function WordpressPage({ content }) {
  if (!content) {
    return null
  }

  return (
    <div
      className="wordpress-page prose dark:prose-invert mx-auto flex flex-col gap-2"
      dangerouslySetInnerHTML={{ __html: content }}
    />
  )
}
